<template>
  <div>
    <!-- <general-top-bar :title="$t('gestiune.ordersSuppliers')"></general-top-bar> -->
    <div id="outer-container">
        <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
            <div class="card-content">
                <div class="clearfix row pad-lf-10 pad-rg-10">
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isMyOrders }"
                      @click="openMyOrders"
                    >{{$t('gestiune.myOrders')}}</a>
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isForOrders }"
                      @click="openForOrders"
                    >{{$t('gestiune.forOrders')}}</a>
                </div>
            </div>
        </div>
    </div>
    <div v-if="isMyOrders">
      <ManagementMyOrdersSuppliers :grouped-locations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
    </div>
    <div v-if="isForOrders">
      <ManagementForOrdersSuppliers :grouped-locations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
    </div>
  </div>
</template>

<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import ManagementMyOrdersSuppliers from 'src/components/Dashboard/Views/Management/Suppliers/ManagementMyOrdersSuppliers.vue'
  import ManagementForOrdersSuppliers from 'src/components/Dashboard/Views/Management/Suppliers/ManagementForOrdersSuppliers.vue'

  export default {
    components: {
      // GeneralTopBar,
      ManagementMyOrdersSuppliers,
      ManagementForOrdersSuppliers
    },
    data () {
      return {
        isMyOrders: true,
        isForOrders: false
      }
    },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      },
      gestiuneOptions: {
        type: Array,
        required: true
      }
    },
    created () {},
    methods: {
      openMyOrders () {
        this.isMyOrders = true
        this.isForOrders = false
      },
      openForOrders () {
        this.isMyOrders = false
        this.isForOrders = true
      }
    }
  }
</script>

<style scoped>
.form-check {
display: flex;
gap: 10px;
align-items: flex-start;
}
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}

.left-buttons {
display: flex;
}

.left-buttons el-button {
margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
display: flex; /* Folosește flexbox pentru alinierea orizontală */
justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Suppliers/ManagementSuppliersTabs.vue